import React from 'react'
import { ImageCard } from '@arvoreeducacao/bonsai-ds'
import type { BookShelf, Module } from 'api/data.types'
import Shelf from '../shelf'
import Carousel from 'components/modular/carousel'
import { carouselCollectionShelfSettings } from './constants'
import ShelfLoading from 'components/modular/shelf-loading'
import { tokens } from '@arvoreeducacao/bonsai-core'
import type { LanguageTokens } from 'i18n'
import { useTranslation } from 'i18n'
import { useHistory } from 'react-router-dom'
import FocusableCover from 'components/modular/focusable-cover'

export type CollectionShelfProps = {
  loading?: boolean
  title?: string
  subtitle?: string
  contentFilter?: Module
  content?: Array<BookShelf>
  customClickCollection?: (collection: BookShelf) => void
  pathHandler?: (id: number) => string
  infoItemProps?: {
    collection: Pick<BookShelf, 'id' | 'name' | 'image'>
    customClickCollection?: (collection: BookShelf) => void
  }
}

const CollectionShelf: React.FC<CollectionShelfProps> = ({
  loading,
  customClickCollection,
  title,
  contentFilter,
  content,
  subtitle,
  pathHandler,
  infoItemProps
}) => {
  const { t } = useTranslation()
  const history = useHistory()

  if (loading) return <ShelfLoading height={310} />

  const handleCollectionClick = ({
    customClickCollection = null,
    pathHandler = null,
    collection
  }) => {
    customClickCollection && customClickCollection(collection)
    pathHandler && history.push(pathHandler(collection.id))
  }

  return (
    Boolean(content.length) && (
      <Shelf
        title={title}
        subtitle={subtitle}
        paddingRight={10}
        isSeeAllButtonVisible={false}
      >
        <Carousel
          settings={carouselCollectionShelfSettings}
          spaceBetweenItems={tokens.spacing.horizontalMedium}
          contentFilter={contentFilter}
          title={title}
        >
          {infoItemProps && (
            <FocusableCover
              key={infoItemProps.collection.id}
              title={t(infoItemProps.collection.name as LanguageTokens)}
              onClickBook={() =>
                handleCollectionClick({
                  customClickCollection: infoItemProps.customClickCollection,
                  collection: infoItemProps.collection
                })
              }
            >
              <ImageCard
                id={infoItemProps.collection.id}
                title={t(infoItemProps.collection.name as LanguageTokens)}
                image={infoItemProps.collection.image}
                onClick={() =>
                  handleCollectionClick({
                    customClickCollection: infoItemProps.customClickCollection,
                    collection: infoItemProps.collection
                  })
                }
              />
            </FocusableCover>
          )}
          {content?.map(collection => {
            return (
              <FocusableCover
                key={collection.id}
                title={t(collection.name as LanguageTokens)}
                onClickBook={() =>
                  handleCollectionClick({
                    customClickCollection,
                    pathHandler,
                    collection
                  })
                }
              >
                <ImageCard
                  id={collection.id}
                  title={t(collection.name as LanguageTokens)}
                  image={collection.image}
                  onClick={() =>
                    handleCollectionClick({
                      customClickCollection,
                      pathHandler,
                      collection
                    })
                  }
                />
              </FocusableCover>
            )
          })}
        </Carousel>
      </Shelf>
    )
  )
}

export default CollectionShelf
